// src/components/LanguageSwitcher.js
// Compact language dropdown for navbar

import React from "react";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, FormControl, Box } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { SUPPORTED_LANGUAGES } from "../constants/languages";

const languages = SUPPORTED_LANGUAGES;

function LanguageSwitcher({ variant = "navbar" }) {
  const { i18n } = useTranslation();

  const handleChange = (event) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang);
  };

  // Navbar variant - compact dropdown
  if (variant === "navbar") {
    return (
      <FormControl size="small" sx={{ minWidth: 70 }}>
        <Select
          value={languages.find((l) => l.code === i18n.language)?.code || "en"}
          onChange={handleChange}
          displayEmpty
          sx={{
            color: "inherit",
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255, 255, 255, 0.5)",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255, 255, 255, 0.8)",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "white",
            },
            ".MuiSvgIcon-root": {
              color: "inherit",
            },
            fontSize: "0.875rem",
            height: "36px",
          }}
          renderValue={(value) => {
            const lang = languages.find((l) => l.code === value);
            return lang?.short || "EN";
          }}
        >
          {languages.map((lang) => (
            <MenuItem key={lang.code} value={lang.code}>
              {lang.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  // Drawer variant - full width list item style
  if (variant === "drawer") {
    return (
      <Box sx={{ px: 2, py: 1 }}>
        <FormControl fullWidth size="small">
          <Select
            value={languages.find((l) => l.code === i18n.language)?.code || "en"}
            onChange={handleChange}
            startAdornment={
              <LanguageIcon sx={{ mr: 1, color: "action.active" }} />
            }
          >
            {languages.map((lang) => (
              <MenuItem key={lang.code} value={lang.code}>
                {lang.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    );
  }

  return null;
}

export default LanguageSwitcher;
